import React from "react";
import ProjectGroupHeader from "./ProjectGroupHeader";
import ProjectSummaryItem from "./ProjectSummaryItem";
import { useIsDesktop } from "../../../../shared/hooks/useIsDesktop";
import ProjectNumberCard from "../../../../shared/ProjectCardFrame/ProjectNumberCard";

/**
 * グループ単位のカードUI
 * ヘッダー＋プロジェクト一覧をまとめる
 */
export default function ProjectGroupCard({
  group,
  displayIndex,
  phases,
  selectedWorkHistoryIds,
  processing,
  onToggleSelected,
  onRemoveFromGroup,
  onUngroup,
}) {
  const isGrouped = group.groupId != null;
  const isDesktop = useIsDesktop();

  return (
    <ProjectNumberCard index={displayIndex} contentGap={2}>
      <ProjectGroupHeader
        group={group}
        displayIndex={displayIndex}
        processing={processing}
        onUngroup={onUngroup}
        isDesktop={isDesktop}
        isGrouped={isGrouped}
      />

      {/* プロジェクト一覧 */}
      {group.items.map((workHistory) => (
        <ProjectSummaryItem
          key={workHistory.id}
          group={group}
          workHistory={workHistory}
          phases={phases}
          checked={selectedWorkHistoryIds.includes(workHistory.id)}
          isGrouped={isGrouped}
          processing={processing}
          onToggleSelected={onToggleSelected}
          onRemoveFromGroup={onRemoveFromGroup}
          isDesktop={isDesktop}
        />
      ))}
    </ProjectNumberCard>
  );
}
